module.exports = __webpack_public_path__ + "static/media/Nunito-Light.6a4fadd2.ttf";